import { API_URL } from "./common";
import axios from "axios";
import { useState, useEffect } from 'react';
import { TimeData } from "./Time";

// convert checkouted payment data, compat with paymentdata class
export class CheckoutedData {
    /** @public @type {TimeData} */
    createTime
    /** @public @type {TimeData} */
    checkoutDate
    /** @public @property {string} rent */
    rent
    /** @public @property {string} surtax */
    surtax
    /** @public @property {string} electric */
    electric
    /** @public @property {string} gas */
    gas
    /** @public @property {string} company */
    company
    /** @public @property {string} room */
    room
    /** @public @property {string} total */
    total

    /** @public @type {TimeData?} */
    resRent
    /** @public @type {TimeData?} */
    resElectric
    /** @public @type {TimeData?} */
    resSurtax
    /** @public @type {TimeData?} */
    resGas

    constructor({ total, checkoutDate, createTime, rent, surtax, electric, gas, company, room, resElectric, resGas, resRent, resSurtax }) {
        this.checkoutDate = checkoutDate;
        this.createTime = createTime;
        this.rent = rent;
        this.surtax = surtax;
        this.electric = electric;
        this.gas = gas;
        this.company = company;
        this.room = room;
        this.resElectric = resElectric;
        this.resGas = resGas;
        this.resRent = resRent;
        this.resSurtax = resSurtax;
        this.total = total;
    }

        // "company": "string",
    //   "room": "string",
    //   "now_date": "2024-12-27",
    //   "rent": 0,
    //   "surtax": 0,
    //   "elec_bill": 0,
    //   "gas_bill": 0,
    //   "res_rent": "2024-12-27",
    //   "res_surtax": "2024-12-27",
    //   "res_elec": "2024-12-27",
    //   "res_gas": "2024-12-27",
    //   "checkout_date"

    /** @returns {CheckoutedData} */
    static fromObject(obj) {
        const {res_elec, res_gas, res_rent, res_surtax, now_date, checkout_date, rent, surtax, elec_bill, gas_bill, company, room} = obj;
        return new CheckoutedData({
            checkoutDate: checkout_date ? TimeData.fromText(checkout_date) : null,
            createTime: now_date ? TimeData.fromText(now_date) : null,
            rent,
            surtax,
            electric: elec_bill,
            gas: gas_bill,
            company,
            room,
            total: (+gas_bill + +elec_bill + +surtax + +rent)+"",
            resElectric: res_elec ? TimeData.fromText(res_elec) : null,
            resGas: res_gas ? TimeData.fromText(res_gas) : null,
            resRent: res_rent ? TimeData.fromText(res_rent) : null,
            resSurtax: res_surtax ? TimeData.fromText(res_surtax) : null,
        });
    }

    /** @returns {{ [string]: CheckoutedData }|null} */
    static use() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [data, setData] = useState(null);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(()=>{
            axios.get(API_URL + "/v2/payment/checkout/list", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }).then(response => {
                const mapped = {}
                for (const [companyName, paymentList] of Object.entries(response.data)) {
                    mapped[companyName] = paymentList.map(item => CheckoutedData.fromObject(item));
                }
                setData(mapped)
            }).catch(error => {
                console.error("Error fetching data:", error);
                alert("데이터를 가져오는 중 문제가 발생했습니다.");
            });
        },[]);
        return data;
    }
}
